module.exports = __webpack_public_path__ + "assets/img/thumb-Earlytrade-Website.19fe2d83.jpg";